// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRecordDetailsSummaryDto } from './IRecordDetailsSummaryDto';
import {
    IRecordDetailsSummaryDtoFromJSON,
    IRecordDetailsSummaryDtoFromJSONTyped,
    IRecordDetailsSummaryDtoToJSON,
    IRecordDetailsSummaryDtoToJSONTyped,
} from './IRecordDetailsSummaryDto';
import type { ITaxYearContributionDetailsDto } from './ITaxYearContributionDetailsDto';
import {
    ITaxYearContributionDetailsDtoFromJSON,
    ITaxYearContributionDetailsDtoFromJSONTyped,
    ITaxYearContributionDetailsDtoToJSON,
    ITaxYearContributionDetailsDtoToJSONTyped,
} from './ITaxYearContributionDetailsDto';

/**
 * 
 * @export
 * @interface IContributionRecordAvailableTaxYearsResponseDto
 */
export interface IContributionRecordAvailableTaxYearsResponseDto {
    /**
     * 
     * @type {IRecordDetailsSummaryDto}
     * @memberof IContributionRecordAvailableTaxYearsResponseDto
     */
    record_details: IRecordDetailsSummaryDto;
    /**
     * 
     * @type {{ [key: string]: ITaxYearContributionDetailsDto; }}
     * @memberof IContributionRecordAvailableTaxYearsResponseDto
     */
    contributions_by_tax_year: { [key: string]: ITaxYearContributionDetailsDto; };
}

/**
 * Check if a given object implements the IContributionRecordAvailableTaxYearsResponseDto interface.
 */
export function instanceOfIContributionRecordAvailableTaxYearsResponseDto(value: object): value is IContributionRecordAvailableTaxYearsResponseDto {
    if (!('record_details' in value) || value['record_details'] === undefined) return false;
    if (!('contributions_by_tax_year' in value) || value['contributions_by_tax_year'] === undefined) return false;
    return true;
}

export function IContributionRecordAvailableTaxYearsResponseDtoFromJSON(json: any): IContributionRecordAvailableTaxYearsResponseDto {
    return IContributionRecordAvailableTaxYearsResponseDtoFromJSONTyped(json, false);
}

export function IContributionRecordAvailableTaxYearsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRecordAvailableTaxYearsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_details': IRecordDetailsSummaryDtoFromJSON(json['record_details']),
        'contributions_by_tax_year': (mapValues(json['contributions_by_tax_year'], ITaxYearContributionDetailsDtoFromJSON)),
    };
}

export function IContributionRecordAvailableTaxYearsResponseDtoToJSON(json: any): IContributionRecordAvailableTaxYearsResponseDto {
    return IContributionRecordAvailableTaxYearsResponseDtoToJSONTyped(json, false);
}

export function IContributionRecordAvailableTaxYearsResponseDtoToJSONTyped(value?: IContributionRecordAvailableTaxYearsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_details': IRecordDetailsSummaryDtoToJSON(value['record_details']),
        'contributions_by_tax_year': (mapValues(value['contributions_by_tax_year'], ITaxYearContributionDetailsDtoToJSON)),
    };
}

